/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_JSXRuntime as JSXRuntime,
  rec_Nr as Nr,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_dS as dS,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function ConfirmarFechaTerminada(e) {
  let t = (0, ReactCompiler.c)(15),
    { onConfirmar: n, onDescartar: r } = e,
    i = new Date(),
    a = Array.from(
      {
        length: 7,
      },
      (e, t) => new Date(i.getFullYear(), i.getMonth(), i.getDate() - 6 + t),
    ),
    [o, s] = (0, React.useState)(dS(i)),
    c;
  t[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((c = (
        <p
          className={`text-xs font-medium text-(--text-h)`}
          children={`¿Qué día la terminaste?`}
        />
      )),
      (t[0] = c))
    : (c = t[0]);
  let l = a.map((e, t) => {
      let n = dS(e),
        r = n === o,
        i = t === a.length - 1;
      return (
        <button
          key={n}
          type={`button`}
          onClick={() => s(n)}
          className={`rounded-full border px-2.5 py-1 text-xs transition ${r ? `border-(--accent) bg-(--accent) text-(--accent-fg)` : `border-(--border) text-(--text-h) hover:bg-(--bg)`}`}
          children={
            i
              ? `Hoy`
              : e.toLocaleDateString(`es-PE`, {
                  weekday: `short`,
                  day: `numeric`,
                })
          }
        />
      );
    }),
    u;
  t[1] === l
    ? (u = t[2])
    : ((u = <div className={`flex flex-wrap gap-1.5`} children={l} />),
      (t[1] = l),
      (t[2] = u));
  let f;
  t[3] === r
    ? (f = t[4])
    : ((f = (
        <button
          type={`button`}
          onClick={r}
          className={zo}
          children={`Volver`}
        />
      )),
      (t[3] = r),
      (t[4] = f));
  let p;
  t[5] !== o || t[6] !== n
    ? ((p = (
        <AccionAsync
          onClick={() => n(o)}
          icono={Nr}
          textoOcupado={`Guardando…`}
          children={`Confirmar`}
        />
      )),
      (t[5] = o),
      (t[6] = n),
      (t[7] = p))
    : (p = t[7]);
  let m;
  t[8] !== f || t[9] !== p
    ? ((m = (
        <div
          className={`flex flex-col-reverse gap-2 sm:flex-row sm:justify-end`}
          children={[f, p]}
        />
      )),
      (t[8] = f),
      (t[9] = p),
      (t[10] = m))
    : (m = t[10]);
  let h;
  return (
    t[11] !== c || t[12] !== u || t[13] !== m
      ? ((h = (
          <div
            className={`flex flex-col gap-2 rounded-2xl border border-(--accent-border) bg-(--accent-bg) p-3`}
            children={[c, u, m]}
          />
        )),
        (t[11] = c),
        (t[12] = u),
        (t[13] = m),
        (t[14] = h))
      : (h = t[14]),
    h
  );
}
